require('./dist').register()
